import * as yup from 'yup';

export const sessionSchema = yup.object().shape({
  event_name: yup
    .string()
    .required('Event name is required')
    .min(3, 'Event name must be at least 3 characters')
    .max(150, 'Event name must not exceed 150 characters'),

  description: yup
    .string()
    .required('Description is required')
    .min(3, 'Description must be at least 3 characters')
    .max(2000, 'Description must not exceed 2000 characters'),

  presenter: yup
    .string()
    .required('Presenter is required')
    .min(3, 'Presenter must be at least 3 characters')
    .max(150, 'Presenter must not exceed 150 characters'),

  category: yup.string().required('Category is required'),

  medium: yup.string().required('Language is required'),

  date: yup.date().required('Date is required'),

  startTime: yup.string().required('Start time is required'),

  endTime: yup.string().required('End time is required'),

  // files: yup.mixed().required('File is required'),

  status: yup.string().required('Status is required'),
});

/**
 * Validate form data using yup
 * @param {Object} formData - Data from the form
 * @returns {Object} - Errors object or an empty object
 */
export const validateForm = async (formData) => {
  try {
    await sessionSchema.validate(formData, { abortEarly: false });
    return {}; // No errors
  } catch (err) {
    const errors = {};
    err.inner.forEach((error) => {
      errors[error.path] = error.message;
    });
    return errors;
  }
};
